import React, {createContext, useReducer, useContext} from 'react'

const WorkspaceStateContext = createContext()
const WorkspaceDispatchContext = createContext()

const initialWorkspaceState = {
  search: {
    date_start: new Date(),
    date_end: new Date(),
    dayPart: 0,
    rm_type: '',
    dv_id: '',
    dp_id: '',
    recurrenceType: 'none',
    weekDays: [0, 0, 0, 0, 0, 0, 0],
    frequencyDay: 'mon',
    frequency: '1st',
    deptCode: ''
  }
}

const workspaceReducer = (state, action) => {
  switch (action.type) {
    case 'setWorkspaceSearch':
      return {
        ...state,
        search: {
          ...state.search,
          ...action.payload
        }
      }

    case 'resetWorkspaceSearch':
      return {...initialWorkspaceState}

    default: {
      throw new Error(`Unhandled action type: ' ${action.type}`)
    }
  }
}

const WorkspaceProvider = ({children}) => {
  const [state, dispatch] = useReducer(workspaceReducer, initialWorkspaceState)

  return (
    <WorkspaceStateContext.Provider value={state}>
      <WorkspaceDispatchContext.Provider value={dispatch}>
        {children}
      </WorkspaceDispatchContext.Provider>
    </WorkspaceStateContext.Provider>
  )
}

const useWorkspaceState = () => {
  const context = useContext(WorkspaceStateContext)
  if (context === undefined) {
    throw new Error('useWorkspaceState must be used within a WorkspaceProvider')
  }
  return context
}

const useWorkspaceDispatch = () => {
  const context = useContext(WorkspaceDispatchContext)

  if (context === undefined) {
    throw new Error(
      'useWorkspaceDispatch must be used within a WorkspaceProvider'
    )
  }
  return context
}

export {WorkspaceProvider, useWorkspaceState, useWorkspaceDispatch}
